import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Button,
  Checkbox,
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grow,
  Paper,
  Popper,
} from '@mui/material';

interface State {
  readonly open: boolean;
}
type Props = {
  readonly displayedForces: string[];
  readonly handleDisplayedForcesUpdate: (displayedForce: string) => void;
  readonly disabled: boolean;
};

export default class DisplayForceOptionsButton extends React.Component<Props, State> {
  anchorEl?: HTMLElement;
  state: State = {
    open: false,
  };
  // This might not currently be needed since we have the ClickAwayListener, but it seems conceivable that it could come
  // into play if we added more automatic synchronization, for example.
  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    return props.disabled && state.open ? { open: false } : null;
  }
  render() {
    const { displayedForces, handleDisplayedForcesUpdate } = this.props;
    const { open } = this.state;
    return (
      <div>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          startIcon={<MenuIcon />}
          ref={(node: HTMLButtonElement) => {
            this.anchorEl = node;
          }}
          aria-owns={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          disabled={this.props.disabled}
          onClick={() => void this.setState({ open: true })}
        >
          Display Forces
        </Button>
        <Popper sx={{ zIndex: 100000 }} open={open} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={() => this.setState({ open: false })}>
                  <FormControl sx={{ m: 1 }} component="fieldset">
                    <FormGroup>
                      <>
                        <FormControlLabel
                          key="deflectionCurves"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('deflectionCurves')}
                              onClick={() => handleDisplayedForcesUpdate('deflectionCurves')}
                            />
                          }
                          label="Member Deflection Curves (in.)"
                        />
                        <FormControlLabel
                          key="deflectionLinkCurves"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('deflectionLinkCurves')}
                              onClick={() => handleDisplayedForcesUpdate('deflectionLinkCurves')}
                            />
                          }
                          label="Link Deflection Curves"
                        />
                        <FormControlLabel
                          key="forceProof"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('forceProof')}
                              onClick={() => handleDisplayedForcesUpdate('forceProof')}
                            />
                          }
                          label="Force Proof"
                        />
                        <FormControlLabel
                          key="loadBearingReactions"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('bearingReactions')}
                              onClick={() => handleDisplayedForcesUpdate('bearingReactions')}
                            />
                          }
                          label="Bearing Reactions (lbs)"
                        />
                        <FormControlLabel
                          key="localLinkEndForces"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('localLinkEndForces')}
                              onClick={() => handleDisplayedForcesUpdate('localLinkEndForces')}
                            />
                          }
                          label="Link End Forces Axial and Transverse (lbs, lb-in.)"
                        />
                        <FormControlLabel
                          key="linkEndForces"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('linkEndForces')}
                              onClick={() => handleDisplayedForcesUpdate('linkEndForces')}
                            />
                          }
                          label="Link End Forces-Global (lbs, lb-in.)"
                        />
                        <FormControlLabel
                          key="momentCurves"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('momentCurves')}
                              onClick={() => handleDisplayedForcesUpdate('momentCurves')}
                            />
                          }
                          label="Moment Curves"
                        />
                        <FormControlLabel
                          key="platingForces"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('platingForces')}
                              onClick={() => handleDisplayedForcesUpdate('platingForces')}
                            />
                          }
                          label="Plating Forces (lbs, lb-in.)"
                        />
                        <FormControlLabel
                          key="shearCurves"
                          control={
                            <Checkbox
                              color="default"
                              checked={displayedForces.includes('shearCurves')}
                              onClick={() => handleDisplayedForcesUpdate('shearCurves')}
                            />
                          }
                          label="Shear Curves"
                        />
                      </>
                    </FormGroup>
                  </FormControl>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}
